import styled from 'styled-components';

const DoubleContactTableWrapper = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  gap: 16px;
  width: 100%;
`;

const TableEmail = styled.div`
  word-break: break-all;
`;

const TableName = styled.p`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  max-width: 220px;
  overflow: hidden;
`;

const AddContactWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;

  width: calc(50% - 48px);
`;

const NavigationButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;

const NavigationButton = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TableHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const TitleWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 32px;
  line-height: 32px;
`;

const CustomRemoveEmptyTableWrapper = styled.div`
  display: flex;
  height: 642px;
  justify-content: center;
  text-align: center;
`;

export {
  AddContactWrapper,
  CustomRemoveEmptyTableWrapper,
  DoubleContactTableWrapper,
  NavigationButton,
  NavigationButtons,
  TableEmail,
  TableHeader,
  TableName,
  TitleWrapper
};
